import { JSX, useContext, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { APIconsSettings, APThemeProvider, getTheme } from '@ap/design-system';
import { AppContext } from './App';
import '../template/assets/style/main.scss';

interface Props {
  children: JSX.Element;
}

interface Props2 {
  children: JSX.Element;
  /**
   * The theme to use for the design system.
   */
  theme: 'light' | 'dark';
}

function AppThemeProvider2(props: Props2) {
  const theme = useMemo(() => {
    return getTheme(props.theme);
  }, [props.theme]);

  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}

const iconsSettings: APIconsSettings = {
  // Required: list of icons that should be loaded
  // The design system automatically includes its mandatory icons.
  icons: [
    'ContentCopy',
    'DarkMode',
    'Delete',
    'Download',
    'Edit',
    'History',
    'Info',
    'KeyboardArrowDown',
    'KeyboardArrowUp',
    'LightMode',
    'Logout',
    'Settings',
    'SupervisorAccount',
    'Upload',
    'UploadFile',
  ],

  // Optional: list of weights for the icons
  // If not provided, the default weights are 300 and 400
  // weights: [200, 300, 400],

  // Optional: list of optical sizes for the icons
  // If not provided, the default optical sizes is 24
  // opticalSize: [24, 48],
};

function AppThemeProvider(props: Props) {
  const { regionalFormat, darkMode } = useContext(AppContext);

  return (
    <AppThemeProvider2 theme={darkMode ? 'dark' : 'light'}>
      <APThemeProvider theme={darkMode ? 'dark' : 'light'} iconsSettings={iconsSettings}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={regionalFormat}>
          {props.children}
        </LocalizationProvider>
      </APThemeProvider>
    </AppThemeProvider2>
  );
}

export default AppThemeProvider;
